/* eslint-disable import/no-extraneous-dependencies */
import { useState, useDeferredValue, useEffect } from 'react';
import PropTypes from 'prop-types';
import { status } from 'constants/general';
import { useSelector, useDispatch } from 'react-redux';
import { providerTypes } from 'constants/providerTypes';
import Button from 'modules/common/components/Button';
import Popup from 'modules/common/components/Popup';
import ItemWithImageSearchField from 'modules/common/components/ItemWithImageSearchField';
import { fetchPharmaciesList, submitProvidersBulk } from 'modules/categories/categoriesSlice';
import { getPharmaciesListForDropDown } from './helper';
import {
  PopupTitleSpan,
  PopupWrapper,
  PopupTitle,
  PopupTitleWrapper,
  Container,
  PopupTitleContainer,
  extendSearchDropDownStyle,
  extendDropDownListItem,
  extendLoaderStyle,
  ButtonsContainer,
  extendGrayButtonStyle,
  extendBlueButtonStyle,
  ItemsContainer,
  ItemContainer,
  ItemWrapper,
} from './AddPharmacyModal.style';
import PharmacyRecord from './PharmacyRecord';

const AddPharmaciesModal = ({ onClose, priceListId }) => {
  const dispatch = useDispatch();
  const pharmacies = useSelector(state => state.categories.pharmacies);
  const submitProvidersBulkState = useSelector(state => state.categories.submitProvidersBulk);
  const isSubmitting = submitProvidersBulkState.status === status.SUBMITING;
  const [selectedProviders, setSelectedProviders] = useState([]);

  const searchPharmacies = keyWord => {
    dispatch(fetchPharmaciesList({ pharmacyName: keyWord }));
  };

  const onSelectPharmacy = async doctorInfo => {
    setSelectedProviders([...selectedProviders, doctorInfo]);
  };

  const removePharmacy = key => {
    const filteredPharmacies = [];
    selectedProviders?.forEach(doctor => {
      if (doctor.key !== key) {
        filteredPharmacies.push(doctor);
      }
    });
    setSelectedProviders(filteredPharmacies);
  };

  const onSave = () => {
    const payload = {
      priceListId: Number(priceListId),
      providerTypeId: providerTypes.PHARMACIES,
      providers: [...selectedProviders],
    };
    const provider = [];
    selectedProviders?.forEach(providerItem => {
      const { key, pharmacyName, imageUrl, areaKey } = providerItem;
      provider.push({
        providerKey: key,
        providerName: pharmacyName,
        providerPhoto: imageUrl,
        areaKey,
      });
      payload.providers = provider;
    });
    dispatch(submitProvidersBulk(payload));
  };

  const onClickClose = () => {
    setSelectedProviders([]);
    onClose();
  };

  const prevSubmitProvidersBulk = useDeferredValue(submitProvidersBulkState.status);

  useEffect(() => {
    if (
      status.SUCCESS === submitProvidersBulkState.status &&
      prevSubmitProvidersBulk !== submitProvidersBulkState.status
    ) {
      onClickClose();
    }
  }, [submitProvidersBulkState.status]);

  return (
    <Popup showCloseBtn={false}>
      <PopupWrapper>
        <PopupTitleContainer>
          <PopupTitleWrapper>
            <PopupTitle>Add Pharmacy</PopupTitle>
            <PopupTitleSpan
              onClick={() => {
                onClickClose();
              }}
            />
          </PopupTitleWrapper>
        </PopupTitleContainer>

        <Container>
          <div
            style={{
              height: '520px',
            }}
          >
            {/** Search */}
            <div
              style={{
                padding: '16px',
                background: '#F1F4F6',
              }}
            >
              <ItemWithImageSearchField
                isRequired
                isDynamic
                isDropDown
                searchable
                key="pharmacies-search-list"
                componentName="pharmacies-search-list"
                onTypingDelay={500}
                placeHolder="Search for a pharmacy"
                fieldValue=""
                options={getPharmaciesListForDropDown(pharmacies?.data, selectedProviders, 'en')}
                onChanges={payload => {
                  onSelectPharmacy(payload?.extras);
                }}
                onSearch={keyWord => {
                  searchPharmacies(keyWord);
                }}
                language="en"
                isLoading={pharmacies.status === status.FETCHING}
                extendLoaderStyle={extendLoaderStyle}
                isValid
                extendDropDownStyle={extendSearchDropDownStyle}
                extendDropDownListItem={extendDropDownListItem}
                icon="e905"
              />
            </div>
            {/** Added Pharmacies section */}
            <div
              style={{
                height: '375px',
              }}
            >
              {selectedProviders?.length > 0 && (
                <div>
                  <ItemsContainer>
                    <ItemContainer>
                      <ItemWrapper>Pharmacy</ItemWrapper>
                    </ItemContainer>
                    {selectedProviders?.map(item => {
                      const { imageUrl, address, key, pharmacyName } = item;
                      return (
                        <PharmacyRecord
                          key={key}
                          image={imageUrl}
                          name={pharmacyName}
                          specialtyName={address}
                          removeItem={() => removePharmacy(key)}
                        />
                      );
                    })}
                  </ItemsContainer>
                </div>
              )}
            </div>
            <ButtonsContainer>
              <Button
                onClick={() => {
                  onClickClose();
                }}
                btnText="Cancel"
                extendButtonStyle={extendGrayButtonStyle}
                key="dismiss-popup"
              />
              <Button
                onClick={() => {
                  onSave();
                }}
                btnText="Save"
                extendButtonStyle={extendBlueButtonStyle}
                key="proceed-save-view"
                disabled={!(selectedProviders?.length > 0)}
                isLoading={isSubmitting}
                extendLoaderStyle={extendLoaderStyle}
              />
            </ButtonsContainer>
          </div>
        </Container>
      </PopupWrapper>
    </Popup>
  );
};

AddPharmaciesModal.propTypes = {
  onClose: PropTypes.func,
};

export default AddPharmaciesModal;
